( function($) {

    function headerDropdown(e) {
        $( 'a.uk-navbar-toggle-animate svg' ).toggleClass( 'active' );
        //alert("test");
    }

    $( "a.uk-navbar-toggle-animate" ).click( headerDropdown );

} )( jQuery );